/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UrlDetails } from '../models/UrlDetails';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UrlDetailsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get details of url for deep linking
     * Retrieves a UrlDetails resource.
     * @param url url to resolve
     * @param locale iso-639 two-letter code
     * @param currency iso 4217 three-letter code
     * @returns UrlDetails UrlDetails resource
     * @throws ApiError
     */
    public deepLinkingUrlDetailsResolver(
        url: string,
        locale?: string,
        currency?: string,
    ): CancelablePromise<UrlDetails> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/deep-linking/resolve-url',
            query: {
                url: url,
                locale: locale,
                currency: currency,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
